import { TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import { TwitterPicker } from 'react-color';
import React, { useCallback } from 'react';
export const TagColorPicker = ({ color, onChange }) => {
    const handleChange = useCallback((result) => {
        onChange(result.hex);
    }, [onChange]);
    return React.createElement(TwitterPicker, { color: color, colors: TAG_COLORS, onChange: handleChange, triangle: 'hide' });
};
